"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Drawer = void 0;

var _react = _interopRequireDefault(require("react"));

var _styles = require("./styles");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

var Drawer = function Drawer(_ref) {
  var items = _ref.items;
  return _react.default.createElement(_styles.Container, null, items && items.map(function (item, i) {
    return _react.default.createElement(_styles.ImageWrapper, {
      key: "image--".concat(i)
    }, _react.default.createElement(_styles.Image, {
      src: item.src,
      srcSet: item.srcSet,
      alt: item.src
    }));
  }));
};

exports.Drawer = Drawer;